/** @format */

export type CompareProductDetailsError = 'noStyle' | 'noPrices';
